<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Articles " />
            <ArtiCle />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import ArtiCle from '../Articles/ArtiCle.vue'


export default {
    name: 'BenevolePage',
    components: {
        NavBar,
        PageTitle,
        ArtiCle,
        FooterComp,
    }
}
</script>